import {Component} from '@angular/core';
import {LanguageService} from '../../../shared/services/language.service';

@Component({
    selector: 'course-instructor-course-access-support-article',
    template: `
        <ng-container i18n="@@support.articles.instructorCourseAccess">
            <p>Instructors can use the course for free. To prevent abuse of this, we do ask that you enroll at least as many students (with an active license) as instructors.</p>
            <p>When there are not enough active students, access for instructors is limited to the trial version.</p>
            <p>When opening lessons excluded from the trial version, this message will appear:</p>
            <figure>
                <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/insufficientStudents.png" />
            </figure>
        </ng-container>
    `
})
export class InstructorCourseAccessSupportArticleComponent {
    constructor(
        public languageService: LanguageService
    ) {}
}
